import type { FC, ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from '../utils/axios';

interface AuthGuardProps {
	children: ReactNode;
}

export const AuthGuard: FC<AuthGuardProps> = (props) => {
	const { children } = props;
	const navigate = useNavigate();
	const [checked, setChecked] = useState(false);

	useEffect(
		() => {
			// TODO Use custom hook?
			axios.get('/status')
				.then(function (response) {
					if (response.status === 200) {
						if (response.data.authenticated === true) {
							setChecked(true);
						} else if (response.data.authenticated === false) {
							navigate('/login');
						} else {
							// Rollbar?
							console.log('Rollbar');
						}
					} else {
						// Rollbar?
						console.log('Rollbar');
					}
				})
				.catch(function (error) {
					// Rollbar?
					console.log('Rollbar');
				});
		}, [], // eslint-disable-line react-hooks/exhaustive-deps
	);

	if (!checked) {
		return null;
	}

	// If got here, it means that the redirect did not occur, and that tells us that the user is
	// authenticated / authorized.

	return <>{children}</>;
};

AuthGuard.propTypes = {
	children: PropTypes.node,
};
